import { IPreviewDataRows } from '../utils';
import React from 'react';
import DataModelerPreviewDataGrid from '../DataModelerPreviewDataGrid';

interface IProps {
  columnName: string;
  cachedData: IPreviewDataRows | null;
  loading: boolean;
  loadPreviewData: () => void;
  resetPreviewData: () => void;
}

const DerivedColumnEditPreviewData = ({
  columnName,
  cachedData,
  loading,
  loadPreviewData,
  resetPreviewData,
}: IProps) => {
  return (
    <DataModelerPreviewDataGrid
      loading={loading}
      previewCachedData={cachedData}
      loadPreviewData={loadPreviewData}
      resetPreviewData={resetPreviewData}
      headerName={columnName}
      height={'small'}
      lastColumnIsResult={true}
    />
  );
};

export default DerivedColumnEditPreviewData;
